exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.notifications-list[data-v-5976c3bf] {\n  z-index: 10;\n  position: fixed;\n  top: 40px;\n  left: 50%;\n  -webkit-transform: translate(-50%, 50%);\n          transform: translate(-50%, 50%);\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Frontend Parent (Prod)/ui/parents/src/components/controls/Notifications.vue"],"names":[],"mappings":";AAoCA;EACI,YAAW;EACX,gBAAe;EACf,UAAS;EACT,UAAS;EACT,wCAA+B;UAA/B,gCAA+B;CAClC","file":"Notifications.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.notifications-list {\n    z-index: 10;\n    position: fixed;\n    top: 40px;\n    left: 50%;\n    transform: translate(-50%, 50%);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5976c3bf","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/controls/Notifications.vue
// module id = WlJp
// module chunks = 14